import React from 'react';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

import RingilButton from '@components/framework/buttons/RingilButton.tsx';
import SvgCoButtonPlus from '@icons/CoButtonPlus.tsx';

interface ComponentProps {
  title: string;
  onClick: () => void;
  fullWidth?: boolean;
  type?: 'ROUNDED' | 'SQUARE';
  hideButton?: boolean;
  dataTestId?: string;
}

// @TODO: this is crazy, refactor it
const AddButton: React.FC<ComponentProps> = ({ onClick, title, fullWidth = false, type = 'SQUARE', hideButton = false, dataTestId }) => {
  const classes = type == 'SQUARE' ? 'rounded border border-solid border-content-gr2' : 'rounded-2xl';
  return (
    <div className={clsx('inline-flex', fullWidth && 'flex-grow', !hideButton && 'cursor-pointer')} onClick={hideButton ? () => {} : onClick} data-testid={dataTestId}>
      <div className={twMerge(`flex flex-row  gap-4 justify-between items-center p-4  bg-white  ${classes}`, clsx({ 'flex-grow': fullWidth == true }))}>
        <div className={'text-content-brand text-base font-medium  flex-grow'}>{title}</div>
        {hideButton === false && <RingilButton mode={'rect-small'} leftIcon={<SvgCoButtonPlus />} />}
      </div>
    </div>
  );
};

export default AddButton;
